export default {
  // Header
  "title": "Generator Pokémon Acak",
  "subtitle": "Buat Pokémon acak berdasarkan preferensi Anda",
  "home": "Beranda",
  "whichPokemonAmI": "Pokémon Apa Saya?",
  "aboutUs": "Tentang Kami",
  "contactUs": "Hubungi Kami",
  "privacyPolicy": "Kebijakan Privasi",
  
  // Filters
  "filterTitle": "Opsi Filter",
  "generateButton": "Hasilkan Pokémon Acak",
  "generating": "Menghasilkan...",
  "numberOfPokemon": "Jumlah Pokémon",
  "type": "Tipe",
  "generation": "Generasi",
  "minimumRarity": "Kelangkaan Minimum (1-10)",
  "anyType": "Tipe Apa Saja",
  "anyGeneration": "Generasi Apa Saja",
  "anyRarity": "Kelangkaan Apa Saja",
  "countingPokemon": "Menghitung Pokémon yang cocok",
  "matchingPokemonCount": "{{count}} Pokémon yang cocok dengan filter Anda",
  "noPokemonToDisplay": "Tidak ada Pokémon untuk ditampilkan. Hasilkan beberapa Pokémon!",
  
  // Pokemon Types
  "normal": "Normal",
  "fire": "Api",
  "water": "Air",
  "electric": "Listrik",
  "grass": "Rumput",
  "ice": "Es",
  "fighting": "Petarung",
  "poison": "Racun",
  "ground": "Tanah",
  "flying": "Terbang",
  "psychic": "Psikis",
  "bug": "Serangga",
  "rock": "Batu",
  "ghost": "Hantu",
  "dragon": "Naga",
  "dark": "Gelap",
  "steel": "Baja",
  "fairy": "Peri",
  
  // Generations
  "Generation I": "Generasi I",
  "Generation II": "Generasi II",
  "Generation III": "Generasi III",
  "Generation IV": "Generasi IV",
  "Generation V": "Generasi V",
  "Generation VI": "Generasi VI",
  "Generation VII": "Generasi VII",
  "Generation VIII": "Generasi VIII",
  "Generation IX": "Generasi IX",
  
  // Evolution Stage
  "evolutionStage": "Tahap Evolusi",
  "evolutionStageAll": "Semua Tahap",
  "evolutionStageFullyEvolved": "Terevolusi Penuh",
  "evolutionStageNotFullyEvolved": "Belum Terevolusi Penuh",
  
  // About Section
  "aboutTitle": "Tentang Generator Pokémon Acak",
  
  // Section titles
  "introTitle": "Selamat Datang di Generator Pokémon Acak Kami",
  "howToUseTitle": "Cara Menggunakan Generator Pokémon Acak",
  "benefitsTitle": "Manfaat Menggunakan Generator Pokémon Acak Kami",
  "historyTitle": "Sejarah Pokémon",
  "popularPokemonTitle": "Pokémon Populer",
  "popularGamesTitle": "Game Pokémon Populer",
  "tradingContestsTitle": "Perdagangan & Kontes Pokémon",
  "faqTitle": "Pertanyaan Umum",
  "conclusionTitle": "Mulai Petualangan Pokémon Acak Anda Hari Ini!",
  
  // Footer
  "copyright": "© 2025 randompokemon.games",
  "trademark": "Pokémon dan nama karakter Pokémon adalah merek dagang dari Nintendo.",
  "linksTitle": "Tautan Berguna",
  
  // About Us Page
  "aboutUsTitle": "Tentang Kami",
  "aboutUsWhoWeAre": "Siapa Kami",
  "aboutUsWhoWeAreContent1": "Selamat datang di Generator Pokémon Acak, sebuah alat yang dibuat oleh penggemar Pokémon yang bersemangat. Perjalanan kami dimulai pada tahun 2023 ketika sekelompok pengembang yang mencintai pemrograman dan Pokémon memutuskan untuk membuat alat yang bermanfaat bagi komunitas.",
  "aboutUsWhoWeAreContent2": "Tim kami terdiri dari pengembang, desainer, dan kreator konten yang bekerja sama untuk memberikan pengalaman terbaik bagi penggemar Pokémon di seluruh dunia.",
  "aboutUsOurMission": "Misi Kami",
  "aboutUsOurMissionContent1": "Kami bertujuan untuk membuat dunia Pokémon lebih mudah diakses dan menyenangkan bagi semua orang. Alat kami dirancang untuk membantu para pelatih menemukan Pokémon baru, membuat tim yang seimbang, dan menemukan Pokémon yang cocok untuk mereka.",
  "aboutUsOurMissionContent2": "Kami berkomitmen untuk memberikan pengalaman yang ramah pengguna, akurat, dan menyenangkan, menghormati merek Pokémon sambil memberikan nilai kepada komunitas.",
  "aboutUsOurTeam": "Tim Kami",
  "aboutUsOurTeamContent1": "Tim kami yang beragam menggabungkan keahlian dalam pengembangan web, pengetahuan Pokémon, desain pengalaman pengguna, dan manajemen komunitas. Kami bersatu oleh kecintaan pada Pokémon dan komitmen untuk membuat alat berkualitas tinggi.",
  "aboutUsOurTeamContent2": "Setiap anggota tim berkontribusi dengan keterampilan dan perspektif unik mereka untuk membuat Generator Pokémon Acak sebaik mungkin.",
  "aboutUsJoinUs": "Bergabunglah Dengan Kami",
  "aboutUsJoinUsContent": "Kami selalu mencari individu yang bersemangat untuk bergabung dengan komunitas kami. Baik Anda seorang pengembang, desainer, ahli Pokémon, atau pengguna yang antusias, pendapat dan kontribusi Anda disambut baik.",
  
  // Contact Us Page
  "contactUsTitle": "Hubungi Kami",
  "contactUsGetInTouch": "Hubungi Kami",
  "contactUsGetInTouchContent": "Punya pertanyaan, saran, atau umpan balik tentang Generator Pokémon Acak? Kami ingin mendengar dari Anda! Berikut cara Anda dapat menghubungi tim kami.",
  "contactUsEmail": "Email",
  "contactUsPhone": "Telepon",
  "contactUsAddress": "Alamat",
  "contactUsHelpSupport": "Bantuan & Dukungan",
  "contactUsHelpSupportContent": "Butuh bantuan menggunakan alat kami atau mengalami masalah? Tim dukungan kami siap membantu.",
  "contactUsFAQ": "Pertanyaan Umum",
  "contactUsFAQContent": "Sebelum menghubungi kami, silakan periksa bagian FAQ kami yang mencakup banyak pertanyaan dan masalah umum.",
  "contactUsBugReport": "Laporan Bug",
  "contactUsBugReportContent": "Jika Anda menemukan bug atau masalah teknis, harap beri tahu kami dengan mengirim email dengan subjek 'LAPORAN BUG'.",
  
  // Privacy Policy Page
  "privacyPolicyTitle": "Kebijakan Privasi",
  "privacyPolicyIntro": "Pengantar",
  "privacyPolicyIntroContent": "Di Generator Pokémon Acak, kami menghormati privasi Anda dan berkomitmen untuk melindungi data pribadi Anda. Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, dan melindungi informasi Anda saat Anda menggunakan situs web kami.",
  "privacyPolicyInformation": "Informasi yang Kami Kumpulkan",
  "privacyPolicyInformationContent": "Kami mengumpulkan informasi minimal untuk menyediakan dan meningkatkan layanan kami. Ini mungkin termasuk:",
  "privacyPolicyInformationItem1": "Data penggunaan (seperti halaman yang dikunjungi, waktu yang dihabiskan di situs, dan fitur yang digunakan)",
  "privacyPolicyInformationItem2": "Informasi perangkat (jenis browser, sistem operasi, dan resolusi layar)",
  "privacyPolicyInformationItem3": "Alamat IP dan lokasi perkiraan (hanya di tingkat negara)",
  "privacyPolicyCookies": "Cookie dan Teknologi Serupa",
  "privacyPolicyCookiesContent": "Kami menggunakan cookie untuk meningkatkan pengalaman Anda di situs web kami. File teks kecil ini memungkinkan kami mengingat preferensi Anda dan menganalisis penggunaan situs web kami. Anda dapat mengontrol cookie melalui pengaturan browser Anda.",
  "privacyPolicyThirdParty": "Layanan Pihak Ketiga",
  "privacyPolicyThirdPartyContent": "Situs web kami mungkin menggunakan layanan pihak ketiga seperti penyedia analitik dan jaringan pengiriman konten. Layanan ini mungkin mengumpulkan informasi tentang penggunaan situs web kami. Kami memastikan bahwa semua pihak ketiga menghormati privasi Anda dan memproses data dengan tepat.",
  "privacyPolicySecurity": "Keamanan Data",
  "privacyPolicySecurityContent": "Kami mengambil langkah-langkah keamanan yang sesuai untuk melindungi informasi Anda dari akses, perubahan, atau pengungkapan yang tidak sah. Namun, tidak ada metode transmisi melalui Internet yang 100% aman, jadi kami tidak dapat menjamin keamanan mutlak.",
  "privacyPolicyChanges": "Perubahan pada Kebijakan Ini",
  "privacyPolicyChangesContent": "Kami mungkin memperbarui Kebijakan Privasi kami dari waktu ke waktu. Kami akan memberi tahu Anda tentang perubahan apa pun dengan memposting Kebijakan Privasi baru di halaman ini dan memperbarui tanggal 'terakhir diperbarui'.",
  "privacyPolicyContact": "Hubungi Kami",
  "privacyPolicyContactContent": "Jika Anda memiliki pertanyaan tentang Kebijakan Privasi ini, silakan hubungi kami melalui informasi yang disediakan di halaman Hubungi Kami kami.",
  "privacyPolicyLastUpdated": "Terakhir Diperbarui",
  
  // Size matching feature
  "enterHeightWeight": "Masukkan tinggi dan berat badan Anda — lihat Pokémon mana yang cocok dengan Anda!",
  "whichPokemonMatchesSize": "Pokémon mana yang cocok dengan ukuran Anda?",
  "youAreMostLike": "Anda paling mirip",
  "nameLabel": "Nama",
  "heightLabel": "Tinggi",
  "weightLabel": "Berat",
  "heightValid": "Harap masukkan tinggi yang valid (1-300 cm)",
  "weightValid": "Harap masukkan berat yang valid (1-500 kg)",
  "enterDetails": "Masukkan detail Anda",
  "finding": "Mencari...",
  "errorFinding": "Kesalahan saat menemukan Pokémon Anda",
  "matchResult": "{{name}} adalah...",
  "similarityScore": "Skor kemiripan",
  "downloadStarted": "Menyiapkan gambar Anda...",
  "downloadComplete": "Gambar berhasil diunduh!",
  "shareText": "Saya menemukan bahwa saya adalah {{pokemon}}! Temukan Pokémon apa Anda!",
  
  // Which Pokemon Am I Content Sections
  "aboutTool": "Tentang Alat Ini",
  "howToUse": "Cara Menggunakan",
  "benefits": "Manfaat",
  "faq": "Pertanyaan Umum",
  "conclusion": "Kesimpulan",
  "findMyPokemon": "Temukan Pokémon Saya",
  "namePlaceholder": "Masukkan nama Anda",
  "nameRequired": "Nama diperlukan",
  "downloadImage": "Unduh Gambar",
  "tryAgain": "Coba Lagi",
  "madeBy": "Dibuat oleh",

  // New Page: Pokemon Randomizer - About Section Titles (Translated to Indonesian)
  "pokemonRandomizerPageAboutTitle": "Jelajahi Pengalaman Ultimate Pokémon Randomizer",
  "pokemonRandomizer_whatIsItTitle": "Apa Sebenarnya Pokémon Randomizer Itu?",
  "pokemonRandomizer_featuresTitle": "Fitur Utama Alat Pokémon Randomizer Kami",
  "pokemonRandomizer_whyUseTitle": "Mengapa Memulai Petualangan dengan Pokémon Randomizer?",
  "pokemonRandomizer_gettingStartedTitle": "Memulai: Permainan Pokémon Randomizer Pertama Anda",
  "pokemonRandomizer_faqTitle": "Pokémon Randomizer: Pertanyaan yang Sering Diajukan",
  contact: "Kontak",
  contactText: "Punya pertanyaan atau saran? Hubungi kami melalui",
  discordServer: "Server Discord",
  twitter: "Twitter",
  github: "GitHub",
  buyMeACoffee: "Belikan saya kopi",
  pokemonRandomizerPageH1: "Pembuat Acak Pokémon",
  pokemonRandomizerPageSubtitle: "Ciptakan pengalaman Pokémon yang unik dengan mengacak generasi Pokémon Anda, tipe, dan lainnya.",

  // Sub-Footer
  subFooterToolsTitle: "Alat",
  subFooterRandomPokemonGeneratorLink: "Generator Pokémon Acak",
  subFooterPokemonRandomizerLink: "Pembuat Acak Pokémon",
  subFooterWhichPokemonAmILink: "Pokémon Apa Saya?",

  subFooterPokemonDatabaseTitle: "Database Pokémon",
  subFooterPokedexLink: "Pokédex (Segera Hadir)",
  subFooterTypeChartsLink: "Bagan Tipe (Segera Hadir)",
  subFooterMoveListLink: "Daftar Jurus (Segera Hadir)",

  subFooterBlogTitle: "Blog",
  subFooterLatestArticlesLink: "Artikel Terbaru (Segera Hadir)",
  subFooterGuidesTutorialsLink: "Panduan & Tutorial (Segera Hadir)"
};
